import type { ReactNode } from "react";

const POINTS = [
  ["Plan the year", "Mark every day on one wall planner, or fill it from your work calendar."],
  ["Know your balances", "DOILs and holidays worked out for you, fortnight by fortnight."],
  ["Keep the details", "Jobs, hours and expenses in one place, ready when you need them."],
];

/** The signed-out pages' layout: the blue welcome panel, with the page's card beside it. */
export function Splash({ children }: { children: ReactNode }) {
  return (
    <main className="splash">
      <section className="splash-hero">
        <div className="splash-brand">
          <img src="/favicon.svg" alt="" width="40" height="40" />
          <span>
            <b>Work</b> <span>Tracker</span>
          </span>
        </div>
        <div className="splash-pitch">
          <p className="splash-eyebrow">For broadcast crew</p>
          <h1>Your working year, at a glance.</h1>
          <ol className="splash-points">
            {POINTS.map(([title, text], i) => (
              <li key={title}>
                <span className="splash-num" aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span>
                  <b>{title}</b>
                  {text}
                </span>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <section className="splash-side">{children}</section>
    </main>
  );
}
